/* eslint-disable no-shadow */
const state = () => ({
  isOffline: false,
});

// getters
const getters = {
};

  // actions
const actions = {
  setIsOffline({ commit }, { isOffline }) {
    commit('setIsOffline', isOffline);
  },
};

  // mutations
const mutations = {
  setIsOffline(state, isOffline) {
    state.isOffline = isOffline;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/network.js